import React from 'react';
import { StyledBaseTable } from '@components/common/Table/styled';
import { Spin } from 'antd';
import useFetchArchivedOutliers from '@components/ai-roadmap/hooks/useFetchArchivedOutliers';
import { debounce } from 'lodash';
import { FooterWrapper } from './styled';
import { AutoResizer } from 'react-base-table';
import { DataTableWrapper } from '../styled';
import Empty from '@components/viewer-sessions/table/Empty';
import { Retry } from '@components/common';
import { useAtom } from 'jotai';
import { archivedTabSortByAtom } from '../atoms';

function InfiniteScrollTable({ getColumns }) {
  const [sortBy, setSortBy] = useAtom(archivedTabSortByAtom);
  const {
    isLoading,
    isError,
    refetch,
    fetchNextPage,
    isFetchingNextPage,
    rows = [],
    searchText,
    onSearch,
  } = useFetchArchivedOutliers({
    sortBy: { field: sortBy.key, order: sortBy.order },
  });

  const onColumnSort = ({ key, order }) => {
    setSortBy({
      key,
      order,
    });
  };

  const LoadingFooter = () => (
    <FooterWrapper>
      <Spin />
    </FooterWrapper>
  );

  const handleEnd = debounce(() => {
    fetchNextPage();
  }, 300);

  return (
      <Retry
        isLoading={isLoading}
        showError={isError}
        mountChildAlways={false}
        fetchData={refetch}
      >
        <DataTableWrapper>
          <AutoResizer>
            {({ width, height }) => {
              return (
                <StyledBaseTable
                  style={{ marginTop: '5px', width: '100%', display: 'flex', flexGrow: 1 }}
                  headerHeight={50}
                  rowHeight={50}
                  columns={getColumns({ searchText, onSearch })}
                  data={rows}
                  width={width}
                  height={height}
                  sortBy={sortBy}
                  onColumnSort={onColumnSort}
                  emptyRenderer={<Empty />}
                  onEndReachedThreshold={100}
                  onEndReached={handleEnd}
                  footerHeight={isFetchingNextPage ? 25 : 0}
                  footerRenderer={isFetchingNextPage ? LoadingFooter : null}
                />
              );
            }}
          </AutoResizer>
        </DataTableWrapper>
      </Retry>
  );
}

export default React.memo(InfiniteScrollTable);
